import controller from './kelse.controller';
import template from './kelse.html';

export default {
	template,
	bindings: {
		form: '<',
		submission: '<',
		kid: '<',
		parent: '=',
	},
	controller,
	controllerAs: '$ctrl',
};
